import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import { Button } from '../../components';

const getTitle = type => {
	switch (type) {
	case 'privacy_policy':
		return 'Privacy Policy';
	case 'terms_of_use':
	default:
		return 'Terms of Use';
	}
};

const AgreementModal = ({ agreements, isOpen, onCancel, onAcceptAgreement, isSubmittingAgreement = false }) => {
	const [shownAgreement, setShownAgreement] = useState({});
	useEffect(() => {
		if (agreements.length > 0) {
			setShownAgreement(agreements[0]);
		}
	}, [agreements]);

	const handleAcceptClick = () => {
		onAcceptAgreement(shownAgreement.agreement_id);
	};

	return (
		<Modal isOpen={isOpen} contentLabel="Support Ticket" className="modal-dialog agreement-modal">
			<div className="modal-content">
				<div className="modal-header">
					<div className="clearfix">
						<h3 className="modal-title">
							{shownAgreement && getTitle(shownAgreement.type)}
						</h3>
					</div>
				</div>
				<div className="modal-body">
					{shownAgreement && (
						<iframe
							src={shownAgreement.url}
							height={450}
							width="100%"
							style={{ border: 0 }}
						/>
					)}
				</div>
				<div className="modal-footer">
					<div className="pull-right">
						{isSubmittingAgreement && (
							<span className="fa fa-spin fa-spinner mr-lg" />
						)}
						<Button
							title="Decline"
							large
							onClick={onCancel}
							disabled={isSubmittingAgreement}
						/>
						<Button
							title="Agree"
							onClick={handleAcceptClick}
							disabled={isSubmittingAgreement}
							large
							primary
							className="ml"
						/>
					</div>
				</div>
			</div>
		</Modal>
	);
};

AgreementModal.propTypes = {
	isOpen: PropTypes.bool,
	onCancel: PropTypes.func.isRequired,
	agreements: PropTypes.array,
	onAcceptAgreement: PropTypes.func.isRequired,
	isSubmittingAgreement: PropTypes.bool
};

export default AgreementModal;
